import { Autocomplete, Box, Dialog, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getTiposEventos } from '../../services/apis';
import { FormCrearActivad } from './tipoEventos/FormCrearActivad';
import { FormCrearComida } from './tipoEventos/FormCrearComida';
import { FormCamisetas } from './tipoEventos/FormCamisetas';
import { FormLimpiezas } from './tipoEventos/FormLimpiezas';

export const FormCrearEvento = ({ formOpen, cerrarFormulario, fecha, cargarEventos }) => {
	const [tiposEventos, setTiposEventos] = useState([]);
	const [opTiposEventos, setOpTiposEventos] = useState([]);
	const [tEventoSelec, setTEventoSelec] = useState(1);
	const tEventoValue = Number(tEventoSelec?.value || tEventoSelec);
	const tipoClass = {
		1: "events-type-food",
		2: "events-type-cleaning",
		3: "events-type-activity",
		4: "events-type-clothes",
	}[tEventoValue] || "events-type-activity";

	const cargarTiposEventos = async () => {
		try {
			const response = await getTiposEventos();
			setTiposEventos(response.data);
			iterarTipoEventos(response.data);
		} catch (error) {
			console.error("Error en carregar els tipus d'esdeveniment:", error);
		}
	};

	const iterarTipoEventos = (data) => {
		try {
			const tmp = [...data];
			const newTmp = tmp.map((item) => ({
				label: item.nombre,
				value: item.id,
			}));
			setOpTiposEventos(newTmp);
			setTEventoSelec(newTmp[0] || null);
		} catch (error) {
			console.error("Error en carregar tipus d'esdeveniment", error);
		}
	};

	useEffect(() => {
		cargarTiposEventos();
	}, []);

	return (
		<Dialog
			open={formOpen}
			onClose={cerrarFormulario}
			fullWidth
			maxWidth="md"
		>
			<DialogTitle>Crear esdeveniment</DialogTitle>
			<DialogContent dividers
				sx={{ overflowY: "auto", height: "100%" }}>
				<Grid container spacing={2} className="events-create-form events-create-legacy-form">
					<Grid size={{ xs: 12 }}>
						<Box className={`events-create-section events-create-type-section ${tipoClass}`}>
							<Typography className="events-create-section-title">Tipus</Typography>
							<Autocomplete
								fullWidth
								disablePortal
								id="combo-box-demo"
								name="Tipus d'esdeveniment"
								options={opTiposEventos}
								value={tEventoSelec}
								onChange={(event, newValue) => setTEventoSelec(newValue)}
								renderInput={(params) => (
									<TextField {...params} label="Tipus d'esdeveniment*" />
								)}
							/>
						</Box>
					</Grid>
					<FormCrearActivad fecha={fecha} cargarEventos={cargarEventos} cerrarFormulario={cerrarFormulario} tEventoSelec={tEventoValue} />
					<FormCrearComida fecha={fecha} cargarEventos={cargarEventos} cerrarFormulario={cerrarFormulario} tEventoSelec={tEventoValue} />
					<FormCamisetas tEventoSelec={tEventoValue} fecha={fecha} cargarEventos={cargarEventos} cerrarFormulario={cerrarFormulario}></FormCamisetas>
					<FormLimpiezas tEventoSelec={tEventoValue} fecha={fecha} cargarEventos={cargarEventos} cerrarFormulario={cerrarFormulario}></FormLimpiezas>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};
